const medications = (count: number) => `medication${count === 1 ? '' : 's'}`;

export const medRec = {
  tab: 'MedRec',
  hint: 'Move each medication the patient is still taking to Reconciled, then Lock & Certify.',
  showing: (current: number, total: number) => `Showing ${current} current medications of ${total}`,
  searchPlaceholder: 'Search medications',
  needsReconciliation: {
    title: (count: number) => `Needs reconciliation · ${count}`,
    subtitle: 'Not confirmed yet. Move the ones the patient is taking to the right.',
    addSelected: (count: number) => `Add ${count} selected`,
    addTooltip: 'Mark as reconciled',
    addAriaLabel: (name: string) => `Mark ${name} as reconciled`,
    dropLabel: 'Drag here to move back to needs reconciliation',
    allReconciled: "Everything is reconciled. Lock & Certify when you're ready.",
    previouslyReconciled: {
      title: (count: number) => `Previously reconciled · ${count}`,
      caption: 'Confirmed before. They will need review again unless you add them back.',
      addAllBack: 'Add all back'
    },
    notReviewed: {
      title: (count: number) => `Not reviewed yet · ${count}`,
      caption: 'Add the ones the patient is taking',
      addAll: 'Add all'
    }
  },
  reconciled: {
    title: (count: number) => `Reconciled · ${count}`,
    subtitle: 'Confirmed with the patient. Saved when you Lock & Certify.',
    clearList: 'Clear list',
    removeTooltip: 'Move back to needs reconciliation',
    removeAriaLabel: (name: string) => `Move ${name} back to needs reconciliation`,
    dropLabel: 'Drag here, or use + to mark as reconciled',
    empty: 'Nothing here yet. Add the medications the patient is taking.'
  },
  duplicate: {
    sameName: 'Another entry for this drug is already in Reconciled. Add this one only if the patient follows these directions too.',
    alsoListedAs: (name: string) => `Also listed as ${name}. Check the directions before adding both.`
  },
  footer: {
    nothingToSave: 'Nothing to save',
    sendingBackForReview: (count: number) => `Locking will send ${count} ${medications(count)} back for review`,
    addedNotSaved: (count: number) => `${count} ${medications(count)} added, not saved yet`,
    keepReconciled: 'Keep them reconciled',
    undoAll: 'Undo all',
    lockAndCertify: (count: number) => `Lock & Certify ${count}`
  }
} as const;
